import { render } from "./ReferenceInfoModal.vue?vue&type=template&id=70e84d04&scoped=true"
import script from "./ReferenceInfoModal.vue?vue&type=script&lang=js"
export * from "./ReferenceInfoModal.vue?vue&type=script&lang=js"

import "./ReferenceInfoModal.vue?vue&type=style&index=0&id=70e84d04&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e84d04"]])

export default __exports__